import { useState } from 'react'
import { IGuarantorOption } from 'components/modals/guarantorPicker'
import StepGuarantor from '../steps/StepGuarantor'

/**
 * «ضامن (اختیاری)», folded into the terms step.
 *
 * It used to be a step of its own, and a step every grant had to walk
 * through — including the majority that have no guarantor at all, for whom
 * it was one more screen and one more «بدون ضامن ادامه بده». A manager asked
 * for the flow to be shorter (pwa#128), so it is a closed section now: one
 * tap takes the borrower's ضامن عضویت (the person who ends up backing the
 * loan in the overwhelming majority of cases), one tap opens the full list.
 */
export default function GuarantorSection({
    moneypoolId,
    borrowerPoolshipId,
    borrowerName,
    suggested,
    value,
    onChange,
    onOpen,
}: {
    moneypoolId?: string
    borrowerPoolshipId?: number
    borrowerName?: string
    suggested?: IGuarantorOption | null
    value: IGuarantorOption[]
    onChange: (next: IGuarantorOption[]) => void
    onOpen?: () => void
}) {
    const [open, setOpen] = useState(false)

    const openList = () => {
        setOpen(true)
        onOpen?.()
    }

    return (
        <>
            <div className=" mt-3 rounded-2xl border border-stroke bg-white p-4">
                <div className=" flex items-center justify-between">
                    <p className=" text-xs font-bold text-brand-deep">
                        ضامن{' '}
                        <span className=" font-normal text-text-secondary">
                            (اختیاری)
                        </span>
                    </p>
                    {open && (
                        <button
                            type="button"
                            onClick={() => setOpen(false)}
                            className=" text-[11px] font-bold text-brand-deep"
                        >
                            بستن فهرست
                        </button>
                    )}
                </div>

                {value.length > 0 ? (
                    <div className=" mt-2 flex items-center justify-between gap-2">
                        <p className=" text-sm font-bold text-heading">
                            {value.map((item) => item.name).join('، ')}
                        </p>
                        {!open && (
                            <button
                                type="button"
                                onClick={openList}
                                className=" shrink-0 text-[11px] font-bold text-brand-deep"
                            >
                                تغییر
                            </button>
                        )}
                    </div>
                ) : (
                    !open && (
                        <div className=" mt-2 space-y-2">
                            {suggested && (
                                <button
                                    type="button"
                                    onClick={() => onChange([suggested])}
                                    className=" w-full rounded-full border border-brand bg-brand-soft py-2 text-[11px] font-bold text-brand-deep"
                                >
                                    {suggested.name} ضامن باشد (ضامن عضویت)
                                </button>
                            )}
                            <button
                                type="button"
                                onClick={openList}
                                className=" w-full rounded-full border border-stroke py-2 text-[11px] font-bold text-text-secondary"
                            >
                                انتخاب ضامن از اعضا
                            </button>
                            <p className=" text-[10px] text-text-muted">
                                بدون ضامن هم می‌توانید ادامه دهید.
                            </p>
                        </div>
                    )
                )}
            </div>

            {open && (
                <div className=" mt-2">
                    <StepGuarantor
                        moneypoolId={moneypoolId}
                        borrowerPoolshipId={borrowerPoolshipId}
                        borrowerName={borrowerName}
                        suggested={suggested}
                        value={value}
                        onChange={onChange}
                    />
                </div>
            )}
        </>
    )
}
